import React from 'react';
import { useSelector } from 'react-redux';
import { CModalFooter } from '@coreui/react';
import { useDispatch, useStore } from 'react-redux';
import { setToast } from '../../../redux/actions/window';
import { changeOpenedModal } from '../../../redux/actions/headerModal';
import {
  cancelBooking,
  cancelBookingV3,
  editingParAmBooking,
  getBookingsCalendarV3,
  getBookingsListV3,
  getSelectedBookings
} from '../../../redux/actions/bookingParAm';
import { buildListV3Params } from './bookingsFilterHelpers';
import { useTranslation } from 'react-i18next';
import { ModalHeader, StyledModal, StyledModalBody } from '../../../components/Modals';
import { SettingsModalLightText } from '../../settings/SettingsModals';
import { Button } from '../../../components/ui/Button';

const ModalCancelConfirmation = () => {
  const { cancelModal, modal } = useSelector((state) => state.headerModal);
  const { booking } = useSelector((state) => state.parAmBooking);
  const { globalBuildingId } = useSelector((state) => state.building);

  const dispatch = useDispatch();
  const store = useStore();
  const { t } = useTranslation();
  const onClose = () => {
    dispatch(
      changeOpenedModal({
        modal: modal === 'bookingsListCancel' ? '' : modal,
        cancelModal: false
      })
    );
  };

  const { globalOrgId } = useSelector((state) => state.Organization);

  const handleCancelSuccess = () => {
    dispatch(
      changeOpenedModal({
        modal: '',
        cancelModal: false
      })
    );

    if (modal === 'bookingDetailsV2' || modal === 'bookingsListCancel') {
      const latest = store.getState();
      const calendarSnap = latest.parAmBooking.lastBookingsCalendarV3Params;
      const buildingId = latest.building.globalBuildingId;
      const orgId = latest.Organization.globalOrgId;

      if (calendarSnap && Number(calendarSnap.building) === Number(buildingId)) {
        dispatch(getBookingsCalendarV3(calendarSnap));
      }
      dispatch(
        getBookingsListV3(
          buildListV3Params({
            buildingId,
            page: 1,
            search: latest.parAmBooking.search,
            orgId
          })
        )
      );
    } else {
      dispatch(
        getSelectedBookings({
          id: globalBuildingId,
          page: 1,
          amenityId: 0,
          orgId: globalOrgId
        })
      );
    }

    dispatch(editingParAmBooking({ editBooking: false }));
    dispatch(
      setToast({
        toastShow: true,
        toastMessage: t('Booking cancelled successfully')
      })
    );
  };

  const handleCancelFail = (err) => {
    dispatch(
      setToast({
        toastShow: true,
        toastMessage: err?.data?.message || t('Failed to cancel booking'),
        modal: 'errorToast'
      })
    );
  };

  const handleConfirmCancel = () => {
    const payload = {
      id: booking.id,
      success: handleCancelSuccess,
      fail: handleCancelFail
    };

    if (modal === 'bookingDetailsV2' || modal === 'bookingsListCancel') {
      dispatch(cancelBookingV3(payload));
    } else {
      dispatch(cancelBooking(payload));
    }
  };

  return (
    <>
      <StyledModal show={cancelModal} onClose={onClose} closeOnBackdrop={false} width="600px">
        <ModalHeader title={t('Cancel this booking?')} onCloseCallback={onClose} />
        <StyledModalBody>
          <SettingsModalLightText>
            {t(
              'Are you sure you want to cancel this booking? The tenant will be notified about the cancellation. This action cannot be undone.'
            )}
          </SettingsModalLightText>
        </StyledModalBody>
        <CModalFooter className="p-0">
          <Button onClick={onClose} text={t('Close')} width={'100px'} />
          <Button
            isPrimary
            type="button"
            text={t('Confirm')}
            width={'100px'}
            onClick={handleConfirmCancel}
          />
        </CModalFooter>
      </StyledModal>
    </>
  );
};

export default ModalCancelConfirmation;
